// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import clsx from 'clsx';
/**
 * Builds the shared grouped-control CSS classes for a consumer.
 *
 * Returns an empty string when the control is not in a group (falsy `position`),
 * otherwise the `grouped` base class plus the position/direction modifier.
 * Pass the result into `clsx(...)` at the call site.
 */
export function getGroupedControlClassNames(styles, { position, direction, hasAction, validation }) {
    if (!position) {
        return '';
    }
    const isFirstInRow = direction === 'vertical' || position === 'first' || position === 'only';
    return clsx(styles.grouped, styles[`grouped-${direction}-${position}`], hasAction && styles['grouped-with-action'], validation && (validation === 'error' ? styles['grouped-with-error'] : styles['grouped-with-warning']), isFirstInRow && styles['grouped-row-first']);
}
//# sourceMappingURL=grouped-control-styles.js.map